"use client";

import { c as _c } from "react/compiler-runtime";
import { Modal } from "@opensea/ui-kit";
import { useOnChange, useVisibilityChange } from "@opensea/ui-kit/hooks";
import { useAccount, useConnectors, useIsReady, useSyncAuth } from "@opensea/wallet";
import { useEffect, useState } from "react";
import { useDisconnect } from "@/hooks/use-disconnect";
import { useAddress, useAuthenticated } from "@/hooks/wallet";
import { LinkWalletChangeDetectedModalContent } from "../LinkWalletFlow/LinkWalletChangeDetectedModalContent";
import { useLinkedAddresses } from "./use-linked-addresses";
const POLL_INTERVAL = 2000;
export const AccountSwitchDetectedFlow = () => {
  const $ = _c(35);
  const address = useAddress();
  const ready = useIsReady();
  const connected = ready && Boolean(address);
  const authenticated = useAuthenticated();
  const {
    syncAuth
  } = useSyncAuth();
  const {
    hasAcceptedTerms
  } = useAccount();
  const {
    activeConnector
  } = useConnectors();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      source: "AccountSwitchDetectedFlow"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const disconnect = useDisconnect(t0);
  const isPageVisible = useVisibilityChange();
  const {
    linkedAddresses,
    refetchLinkedAddresses,
    fetching
  } = useLinkedAddresses();
  const [isSwitchingAccounts, setIsSwitchingAccounts] = useState(false);
  const [fetchingInitialValue, setFetchingInitialValue] = useState(true);
  let t1;
  if ($[1] !== fetching || $[2] !== fetchingInitialValue) {
    t1 = () => {
      if (fetchingInitialValue) {
        setFetchingInitialValue(fetching);
      }
    };
    $[1] = fetching;
    $[2] = fetchingInitialValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== fetching) {
    t2 = [fetching];
    $[4] = fetching;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== address || $[7] !== authenticated || $[8] !== connected || $[9] !== fetchingInitialValue || $[10] !== hasAcceptedTerms || $[11] !== isSwitchingAccounts || $[12] !== linkedAddresses) {
    t3 = (connected && authenticated === true || isSwitchingAccounts) && hasAcceptedTerms === true && fetchingInitialValue === false && !!address && (linkedAddresses.length === 0 || !linkedAddresses.includes(address));
    $[6] = address;
    $[7] = authenticated;
    $[8] = connected;
    $[9] = fetchingInitialValue;
    $[10] = hasAcceptedTerms;
    $[11] = isSwitchingAccounts;
    $[12] = linkedAddresses;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const open = t3;
  let t4;
  if ($[14] !== refetchLinkedAddresses || $[15] !== syncAuth) {
    t4 = () => {
      syncAuth();
      refetchLinkedAddresses();
    };
    $[14] = refetchLinkedAddresses;
    $[15] = syncAuth;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const refreshState = t4;
  let t5;
  if ($[17] !== refreshState) {
    t5 = () => {
      setFetchingInitialValue(true);
      refreshState();
    };
    $[17] = refreshState;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  useOnChange(address, t5);
  let t6;
  let t7;
  if ($[19] !== isPageVisible || $[20] !== open || $[21] !== refreshState) {
    t6 = () => {
      if (open && isPageVisible) {
        const interval = setInterval(() => {
          refreshState();
        }, POLL_INTERVAL);
        return () => {
          clearInterval(interval);
        };
      }
    };
    t7 = [open, isPageVisible, refreshState];
    $[19] = isPageVisible;
    $[20] = open;
    $[21] = refreshState;
    $[22] = t6;
    $[23] = t7;
  } else {
    t6 = $[22];
    t7 = $[23];
  }
  useEffect(t6, t7);
  let t8;
  if ($[24] !== activeConnector || $[25] !== address || $[26] !== isSwitchingAccounts || $[27] !== refetchLinkedAddresses) {
    t8 = address && activeConnector ? <LinkWalletChangeDetectedModalContent address={address} connector={activeConnector} isSwitchingAccounts={isSwitchingAccounts} onLinked={() => {
      refetchLinkedAddresses();
    }} onLoggedIn={() => {
      refetchLinkedAddresses();
    }} setIsSwitchingAccounts={setIsSwitchingAccounts} /> : null;
    $[24] = activeConnector;
    $[25] = address;
    $[26] = isSwitchingAccounts;
    $[27] = refetchLinkedAddresses;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== disconnect) {
    t9 = open_0 => {
      if (!open_0) {
        disconnect();
      }
    };
    $[29] = disconnect;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== open || $[32] !== t8 || $[33] !== t9) {
    t10 = <Modal className="md:rounded-xl" content={t8} onOpenChange={t9} open={open} withCloseIcon={false} />;
    $[31] = open;
    $[32] = t8;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
};